// localStorage Utilities - Centralized storage operations with error handling
// Provides safe and consistent localStorage operations across the app

const localStorage_utils = {
  // Generic get function with error handling
  get: (key, defaultValue = null) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : defaultValue;
    } catch (error) {
      console.warn(`Failed to get localStorage item '${key}':`, error);
      return defaultValue;
    }
  },

  // Generic set function with error handling
  set: (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      console.warn(`Failed to set localStorage item '${key}':`, error);
      return false;
    }
  },

  // Remove function with error handling
  remove: (key) => {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.warn(`Failed to remove localStorage item '${key}':`, error);
      return false;
    }
  },

  // Clear all localStorage
  clear: () => {
    try {
      localStorage.clear();
      return true;
    } catch (error) {
      console.warn('Failed to clear localStorage:', error);
      return false;
    }
  },

  // Check if localStorage is available
  isAvailable: () => {
    try {
      const testKey = '__localStorage_test__';
      localStorage.setItem(testKey, 'test');
      localStorage.removeItem(testKey);
      return true;
    } catch {
      return false;
    }
  },

  // Specific methods for common app operations
  bookmarks: {
    get: (key) => {
      const bookmarks = localStorage_utils.get(key, []);
      return new Set(bookmarks);
    },
    
    set: (key, bookmarksSet) => {
      return localStorage_utils.set(key, [...bookmarksSet]);
    }
  },

  // Get storage usage information
  getStorageInfo: () => {
    if (!localStorage_utils.isAvailable()) return null;
    
    let totalSize = 0;
    let items = {};
    
    try {
      for (let key in localStorage) {
        if (localStorage.hasOwnProperty(key)) {
          const size = (localStorage[key].length + key.length) * 2; // Rough byte estimate
          items[key] = size;
          totalSize += size;
        }
      }
      
      return {
        totalSize: totalSize,
        totalSizeKB: Math.round(totalSize / 1024 * 100) / 100,
        itemCount: Object.keys(items).length,
        items: items
      };
    } catch (error) {
      console.warn('Failed to get storage info:', error);
      return null;
    }
  }
};

export default localStorage_utils;